import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {CompRef} from '@wix/document-services-types'
import {generateAndInjectImages} from './utils'
import {fetchMatchingImages, type MatchImageToPageParams} from './requests'

export const matchImagesToPage = async (
    environmentContext: EnvironmentContext,
    createExtArgs: CreateExtArgs,
    componentPointers: CompRef[],
    siteDescription: string
): Promise<void> => {
    return generateAndInjectImages<MatchImageToPageParams>(
        environmentContext,
        createExtArgs,
        componentPointers,
        (_key, url, width, height) => ({
            width_RunwareFlux: width.toString(),
            height_RunwareFlux: height.toString(),
            userImage: url,
            Site_Description: siteDescription
        }),
        fetchMatchingImages
    )
}
